'use client';
import type { SVGProps } from "react";
import type { FC } from 'react';
import type { IconProps } from '../utils/type';
import { SvgIconWrapper } from '../utils/svg-icon-wrapper';
/**
 * Auto-generated icon component: Do not change this component manually.
 * Config file: customSvgrTemplate.js
 */
const SvgBase: FC<IconProps> = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}><path fill="currentColor" fillRule="evenodd" d="M2.053 4.106a1 1 0 0 0-.447 1.341q.111.226.25.516c.488 1.013 1.23 2.56 2.298 3.908C5.442 11.498 7.326 13 10 13h8.657l-1.828 1.828a1 1 0 0 0 1.414 1.415L22.486 12l-4.243-4.243a1 1 0 1 0-1.414 1.415L18.657 11H10c-1.825 0-3.192-.998-4.278-2.37-.914-1.155-1.544-2.46-2.036-3.48a48 48 0 0 0-.291-.597 1 1 0 0 0-1.342-.447m3.17 8.859c.568.401 1.2.752 1.897 1.016a7.6 7.6 0 0 0-1.398 1.39c-.914 1.154-1.544 2.459-2.036 3.48q-.155.319-.291.596a1 1 0 1 1-1.79-.894q.113-.226.252-.516c.486-1.013 1.23-2.56 2.297-3.908.319-.403.674-.798 1.069-1.164" clipRule="evenodd" /></svg>;
const IconSimilarities = ({
  $size,
  $color,
  className,
  ...rest
}: IconProps) => <SvgIconWrapper $size={$size} $color={$color} className={className}><SvgBase {...rest} /></SvgIconWrapper>;
export default IconSimilarities;